import { gql } from "@apollo/client";

export const removeUsersQuery = gql`
mutation removeUsersQuery($userIds: [String!]!) {
  removeUsers(userIds: $userIds) {
    success
  }
}
`;
